import { Box, useTheme } from '@mui/material';
import { memo, ReactElement } from 'react';

export interface HeaderBarProps {
  languageSelector?: ReactElement;
}

export const HeaderBar = memo(function (props: HeaderBarProps): ReactElement {
  const { languageSelector } = props;
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: `calc(100% - ${theme.spacing(2 * padding)})`,
        backgroundColor: 'primary.main',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: padding,
        paddingRight: padding,
        paddingTop: 1,
        paddingBottom: 1,
        borderRadius: 0,
      }}
    >
      <Box flex={1} display='flex' alignItems='center'>
        <img
          src='/logo_white.png'
          alt='Logo'
          style={{
            height: theme.spacing(2.5),
            objectFit: 'contain',
          }}
        />
      </Box>

      <Box flex={1} display='flex' alignItems='center' justifyContent='flex-end'>
        {languageSelector}
      </Box>
    </Box>
  );
});

const padding = 3;
